export const ONBOARDING_STEPS = [
    { key: 'business_profile', title: 'Business Profile', description: 'Company details, industry and goals' },
    { key: 'team_setup', title: 'Team Setup', description: 'Users, roles and departments' },
    { key: 'phone_system', title: 'Phone System', description: 'Numbers, routing, hours and voicemail' },
    { key: 'crm_configuration', title: 'CRM Configuration', description: 'Contacts, pipelines and fields' },
    { key: 'texting_automation', title: 'Texting & Automation', description: 'Messages, follow-ups and templates' },
    { key: 'import_integrations', title: 'Import & Integrations', description: 'Existing data and connected tools' },
    { key: 'review_launch', title: 'Review & Launch', description: 'Validation and activation' }
];

export const BUSINESS_PROFILE_SCREENS = {
    PROFILE: 'profile',
    RECOMMENDATIONS: 'recommendations',
    CONFIRM: 'confirm'
};

export const IMPORT_INTEGRATIONS_SCREENS = {
    IMPORT: 'import',
    INTEGRATIONS: 'integrations',
    CONFIRM: 'confirm'
};

export const TEXTING_AUTOMATION_SCREENS = {
    TEMPLATES: 'templates',
    SEQUENCE: 'sequence',
    CONFIRM: 'confirm'
};

export const CRM_CONFIGURATION_SCREENS = {
    PIPELINES: 'pipelines',
    FIELDS: 'fields',
    CONFIRM: 'confirm'
};

export const PHONE_SYSTEM_SCREENS = {
    HOURS: 'hours',
    ROUTING: 'routing',
    CONFIRM: 'confirm'
};

// Same values as the ring group / call queue modal
export const RING_STRATEGY_OPTIONS = [
    { key: 'ringall', value: 'ringall', text: 'Ring All' },
    { key: 'roundrobin', value: 'roundrobin', text: 'Round Robin' }
];

export const NO_ANSWER_OPTIONS = [
    { key: 'company_voicemail', value: 'company_voicemail', text: 'Send to company voicemail' },
    { key: 'hang_up', value: 'hang_up', text: 'Hang up' }
];

export const TEAM_SETUP_SCREENS = {
    STRUCTURE: 'structure',
    INVITES: 'invites',
    CONFIRM: 'confirm'
};

// Used only when DYL's industry list (/v1/company/industry) can't be loaded
export const INDUSTRY_OPTIONS = [
    { key: 'insurance', value: 'insurance', text: 'Insurance' },
    { key: 'real_estate', value: 'real_estate', text: 'Real Estate' },
    { key: 'home_services', value: 'home_services', text: 'Home Services' },
    { key: 'healthcare', value: 'healthcare', text: 'Healthcare' },
    { key: 'financial_services', value: 'financial_services', text: 'Financial Services' },
    { key: 'other', value: 'other', text: 'Other' }
];

export const PRIMARY_GOAL_OPTIONS = [
    { key: 'manage_leads', value: 'manage_leads', text: 'Manage leads and increase sales' },
    { key: 'improve_calling', value: 'improve_calling', text: 'Improve calling' },
    { key: 'automate_follow_ups', value: 'automate_follow_ups', text: 'Automate follow-ups' },
    { key: 'unify_tools', value: 'unify_tools', text: 'Unify tools' },
    { key: 'other', value: 'other', text: 'Something else' }
];

// With "Something else" the goal details are the only signal the recommendations get, so they're required
export const OTHER_GOAL = 'other';

export const GOAL_DETAILS_PLACEHOLDERS = {
    manage_leads: 'e.g. Leads from our website sit for days before anyone calls.',
    improve_calling: 'e.g. We miss calls after 5 PM and on Saturdays.',
    automate_follow_ups: 'e.g. We forget to follow up after sending a quote.',
    unify_tools: 'e.g. We use spreadsheets plus a separate texting app.',
    other: 'e.g. We want to track which marketing campaigns bring in the best customers.'
};

export const RECOMMENDATION_TIERS = {
    RECOMMENDED: 'recommended',
    NEEDS_CONFIRMATION: 'needs_confirmation',
    REQUIRES_ACTIVATION: 'requires_activation'
};

export const RECOMMENDATION_TIER_LABELS = {
    [RECOMMENDATION_TIERS.RECOMMENDED]: { text: 'Recommended', color: 'green' },
    [RECOMMENDATION_TIERS.NEEDS_CONFIRMATION]: { text: 'Needs Confirmation', color: 'orange' },
    [RECOMMENDATION_TIERS.REQUIRES_ACTIVATION]: { text: 'Requires Activation', color: 'blue' }
};

// Fields that, when changed, make previously generated recommendations stale
export const RECOMMENDATION_INPUT_FIELDS = ['industry_id', 'team_size', 'primary_goal', 'goal_details', 'description', 'website_insights'];

export const CONTACT_METHOD_LABELS = {
    phone: 'Phone',
    contact_form: 'Contact form',
    online_booking: 'Online booking',
    live_chat: 'Live chat'
};

// The recommendation engine works with a few broad industry categories; DYL's industry list is much longer.
// Order matters: "Home Health Care" is healthcare, not home services.
const INDUSTRY_CATEGORY_PATTERNS = [
    ['insurance', /insur/],
    ['healthcare', /health|medic|dental|clinic|hospital|pharma|therap|chiro/],
    ['real_estate', /real ?estate|realt|propert/],
    ['financial_services', /financ|bank|mortgage|lend|invest|account|tax|wealth|credit/],
    ['home_services', /home|construct|contract|plumb|hvac|roof|electric|landscap|clean|repair|pest|remodel/]
];

export const getIndustryCategory = (industryName = '') => {
    const name = String(industryName).toLowerCase().replace(/_/g, ' ');
    return INDUSTRY_CATEGORY_PATTERNS.find(([, pattern]) => pattern.test(name))?.[0] || 'other';
}

export const getOptionText = (options, value) => options.find(option => option.value === value)?.text || '';
